(function () {
  // --- TEXTE ---
  var dataEl = document.getElementById('parfums-data');
  var titleEl = document.querySelector('[data-dynamic-variant] .parfum-title');
  var textEl = document.querySelector('[data-dynamic-variant] .parfum-text');
  var parfumsData = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];

  // --- PYRAMIDE ---
  var pyramideEl = document.querySelector('[id^="pyramide-data-"]');
  var pyramideImg = document.querySelector('.pyramide-img');
  var pyramideData = pyramideEl ? JSON.parse(pyramideEl.textContent || '[]') : [];

  // --- NORMALISATION ---
  function normalize(str) {
    return str ? str.toLowerCase().replace(/-/g, ' ').trim() : '';
  }

  function getSelectedVariant() {
    var variantSelects = document.querySelector('variant-selects');
    var checked = variantSelects && variantSelects.querySelector('input[type="radio"]:checked');
    var select = variantSelects && variantSelects.querySelector('select');
    return (checked && checked.value) || (select && select.value) || '';
  }

  function updateContent(variantName) {
    var normalized = normalize(variantName);

    // Texte
    if (dataEl) {
      var i = parfumsData.findIndex(function (p) { return normalize(p.title) === normalized; });
      var data = i >= 0 ? parfumsData[i] : parfumsData[0];
      if (data) {
        if (titleEl) titleEl.textContent = data.title;
        if (textEl) {
          textEl.innerHTML = data.text;
          textEl.querySelectorAll('p').forEach(function (p) {
            p.style.marginBottom = '0.5em';
          });
          var last = textEl.querySelector('p:last-child');
          if (last) last.style.marginBottom = '0';
        }
      }
    }

    // Pyramide
    if (pyramideEl && pyramideImg) {
      var j = pyramideData.findIndex(function (p) { return normalize(p.title) === normalized; });
      var pData = j >= 0 ? pyramideData[j] : pyramideData[0];
      if (pData && pData.image) pyramideImg.src = pData.image;
    }
  }

  // Chargement initial
  setTimeout(function () {
    updateContent(getSelectedVariant());
  }, 500);

  // Dawn émet cet événement à chaque changement de variante
  document.addEventListener('variant:changed', function () {
    setTimeout(function () {
      updateContent(getSelectedVariant());
    }, 100);
  });

  // Fallback : écoute les clics sur les radios directement
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest('variant-selects')) {
      setTimeout(function () {
        updateContent(getSelectedVariant());
      }, 100);
    }
  });
})();
